import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RouteBadge from '#/shared/components/RouteBadge';
import {
  formatDestinations,
  routeTypeToMode,
} from '#/transit-tracker/utils/routes';
import { routeType } from '#/prop-types';
import { BRT_SUB_TYPE } from '#/transit-tracker/constants';
import * as Styled from './styled';

function RouteDetailHeader({
  routeDetail,
  navigateToFullRouteDetails,
  children,
}) {
  const routeIsBrt = routeDetail.routeSubType === BRT_SUB_TYPE;

  return (
    <Styled.RouteDetailHeader>
      <Styled.RouteDetailRow>
        <Styled.RouteDetailHeaderIconColumn aria-hidden="true">
          <Styled.VehicleIcon mode={routeTypeToMode(routeDetail)} />
          <Styled.RouteBadgeWrapper>
            <RouteBadge
              routeId={routeDetail.id}
              size={35}
              useScaling={false}
              useBorder
            />
          </Styled.RouteBadgeWrapper>
        </Styled.RouteDetailHeaderIconColumn>
        <Styled.RouteDetailHeaderNameColumn>
          <Styled.RouteDetailHeaderName>
            {routeDetail.desc}
            <Styled.RouteInfoIconButton onClick={navigateToFullRouteDetails}>
              <Styled.RouteInfoIcon />
            </Styled.RouteInfoIconButton>
          </Styled.RouteDetailHeaderName>
          <Styled.RouteDetailHeaderStopSummary>
            {routeDetail.dir && formatDestinations(routeDetail.dir)}
          </Styled.RouteDetailHeaderStopSummary>
        </Styled.RouteDetailHeaderNameColumn>
      </Styled.RouteDetailRow>
      {routeDetail.frequentService && (
        <Styled.RouteFrequentServiceRow>
          <Styled.FrequentServiceMessageColumn>
            <FormattedMessage
              id={
                routeIsBrt
                  ? 'detailview.routefrequentexpress'
                  : 'detailview.routefrequentservice'
              }
              values={{ name: routeDetail.desc }}
            />
          </Styled.FrequentServiceMessageColumn>
          <Styled.FrequentServiceIconColumn>
            {routeIsBrt ? (
              <Styled.FrequentExpressIcon />
            ) : (
              <Styled.FrequentServiceIcon />
            )}
          </Styled.FrequentServiceIconColumn>
        </Styled.RouteFrequentServiceRow>
      )}
      <Styled.RouteDetailChildRow>{children}</Styled.RouteDetailChildRow>
    </Styled.RouteDetailHeader>
  );
}

RouteDetailHeader.propTypes = {
  /** Contains the details of this route */
  routeDetail: routeType.isRequired,
  /** Redirects user to the full route details page */
  navigateToFullRouteDetails: PropTypes.func.isRequired,
  /** Contains additional children to display inside of this component */
  children: PropTypes.node,
};

RouteDetailHeader.defaultProps = {
  children: null,
};

export default RouteDetailHeader;
